import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/public/Home";
import Menus from "@/pages/public/Menus";
import Boissons from "@/pages/public/Boissons";
import Contact from "@/pages/public/Contact";
import MentionsLegales from "@/pages/public/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/public/PolitiqueConfidentialite";
import TabletCarte from "@/pages/tablet/TabletCarte";
import { BAR_STRUCTURE, BISTRO_STRUCTURE } from "@/lib/carteStructures";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public marketing pages */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/menus" element={<Menus />} />
            <Route path="/boissons" element={<Boissons />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          </Route>

          {/* Hidden tablet pages (no layout, no nav) */}
          <Route path="/carte-bistro" element={<TabletCarte carte="bistro" title="Carte du Bistrot" subtitle="Choisissez une catégorie" structure={BISTRO_STRUCTURE} />} />
          <Route path="/carte-bar" element={<TabletCarte carte="bar" title="Carte du Bar" subtitle="Choisissez une catégorie" structure={BAR_STRUCTURE} />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Catch-all: any old URL from the previous site redirects to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
